/* Unified chart color palette for the analytics dashboard.
 * Import named constants instead of using ad-hoc hex values in components. */

// ── Order status (semantic) ──────────────────────────────────────────
export const STATUS_COLORS = {
    ORDER_PLACED: '#5C6BC0',      // indigo
    INTRANSIT:    '#1E88E5',      // blue
    DELIVERED:    '#43A047',      // green
    DELIVERY_FAILED: '#F57C00',  // orange
    RTO:          '#E53935',      // red
    CANCELLED:    '#616161',      // dark gray
    LOST:         '#FF9800',      // amber
}

// ── Payment mode ─────────────────────────────────────────────────────
export const PAYMENT_COLORS = {
    PREPAID: '#43A047',           // green
    COD:     '#F57C00',           // orange
}

// ── Zone palette ─────────────────────────────────────────────────────
export const ZONE_COLORS = {
    LOCAL:    '#66BB6A',          // green
    METROS:  '#42A5F5',          // blue
    REGIONAL:'#FFA726',          // orange
    ROI:     '#AB47BC',          // purple
    SPECIAL: '#EF5350',          // red
}

// ── Generic chart series (bars, areas, lines) ────────────────────────
export const SERIES_COLORS = [
    '#5C6BC0', // indigo
    '#26A69A', // teal
    '#FFA726', // orange
    '#AB47BC', // purple
    '#42A5F5', // blue
    '#66BB6A', // green
    '#EF5350', // red
    '#8D6E63', // brown
    '#EC407A', // pink
]

// ── Courier/entity stacked area palette (soft, distinguishable) ──────
export const ENTITY_COLORS = [
    '#5C6BC0', // indigo
    '#26A69A', // teal
    '#FFA726', // orange
    '#AB47BC', // purple
    '#42A5F5', // blue
    '#66BB6A', // green
    '#EF5350', // red
    '#8D6E63', // brown
    '#EC407A', // pink
    '#78909C', // blue-gray
]

// ── Accent / line colors ─────────────────────────────────────────────
export const ACCENT = {
    red:    '#E53935',
    green:  '#43A047',
    blue:   '#1E88E5',
    orange: '#F57C00',
}

// ── Ageing buckets (6 steps: best → worst) ────────────────────────────
export const AGEING_COLORS = [
    '#66BB6A', // 0-day  — green
    '#FDD835', // 1-day  — yellow
    '#FFA726', // 2-days — orange
    '#EF5350', // 3-days — red
    '#AB47BC', // 4-days — purple
    '#78909C', // 4+/5+  — blue-gray
]

// ── Resolution ageing (4 buckets) ──────────────────────────────────────
export const RESOLUTION_COLORS = [
    '#66BB6A', // 0-3 days
    '#42A5F5', // 4-7 days
    '#FDD835', // 8-15 days
    '#EF5350', // 15+ days
]

// ── Delivery attempt buckets (5 steps) ─────────────────────────────────
export const ATTEMPT_COLORS = [
    '#EF5350', // 0 attempts — red
    '#FFA726', // 1 attempt  — orange
    '#42A5F5', // 2 attempts — blue
    '#66BB6A', // 3 attempts — green
    '#5C6BC0', // 3+ attempts — indigo
]

// ── SLA adherence (binary: within/not-within) ──────────────────────────
export const ADHERENCE_COLORS = {
    WITHIN:     '#43A047', // green
    NOT_WITHIN: '#EF5350', // red
}

// ── Dual-axis chart fills (count + percentage) ─────────────────────────
export const DUAL_AXIS_COLORS = {
    PRIMARY:   '#5C6BC0', // indigo (count)
    SECONDARY: '#FFA726', // orange (percentage)
}

// ── Muted background bar ───────────────────────────────────────────────
export const MUTED_BAR = '#D5D8DC'

// ── Negative highlight (soft red for area fills) ───────────────────────
export const NEGATIVE_AREA = '#E88A91'

// Legacy default export — kept for existing callers outside the Overall Summary tab
export default function getColor(i) {
    return SERIES_COLORS[i % SERIES_COLORS.length]
}
